<template>
  <header class="sticky-header">
    <div class="container-header">
      <div class="left-section">
        <div class="navigation-icon" @click="toggleNavigation">
          <svg width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="40" height="3" fill="#262523"/>
            <rect y="13" width="40" height="3" fill="#262523"/>
          </svg>
        </div>
        <div class="link-btn-header">
          <NuxtLink to="#" class="btn-configure">{{ $t('header.configure') }}</NuxtLink>
          <NuxtLink to="#" class="btn-find-dealer">{{ $t('header.findADealer') }}</NuxtLink>
        </div>
      </div>
      <div class="middle-section">
        <NuxtLink to="/" aria-label="@lang('Go to home')">
          <img src="/assets/images/logo.png" alt="Athena logo"/>
        </NuxtLink>
      </div>
      <div class="right-section">
        <HeaderSearch/>
        <HeaderAccount/>
        <HeaderCart/>
      </div>
    </div>
  </header>

  <Navigation
    v-if="isNavOpen"
    ref="navContent"
    @close="closeNavigation"
  />
</template>

<script setup lang="ts">
import {ref} from 'vue'
import HeaderAccount from "~/layouts/Header/HeaderAccount.vue"
import HeaderSearch from "~/layouts/Header/HeaderSearch.vue"
import HeaderCart from "~/layouts/Header/HeaderCart.vue"
import {onClickOutside} from '@vueuse/core';

const isNavOpen = ref(false)
const toggleNavigation = () => {
  isNavOpen.value = !isNavOpen.value
}

const closeNavigation = () => {
  isNavOpen.value = false
}
const navContent = ref<HTMLElement | null>(null)
onClickOutside(navContent, () => {
  isNavOpen.value = false
})
</script>
